import { combineReducers } from "redux";
import { createReduxHistoryContext } from "redux-first-history";
import camelCase from "lodash/camelCase";

const reducers = {};

const req = require.context(".", true, /\.\/.+\/reducer\.js$/);

req.keys().forEach(key => {
  const storeName = camelCase(key.replace(/\.\/(.+)\/.+$/, "$1"));
  reducers[storeName] = req(key).default;
});

// eslint-disable-next-line import/no-anonymous-default-export
export default history => {
  const { routerReducer } = createReduxHistoryContext({
    history,
    //other options if needed
  });
  return combineReducers({
    router: routerReducer,
    ...reducers,
  });
};
